const popupTypes = {
  NAVIGATOR_OPTION_POPUP: 'NAVIGATOR_OPTION_POPUP',
}

export default popupTypes
